import React from 'react'

import { LeftArrowCircleIcon, RightArrowCircleIcon } from 'images'

import { useMediaExpandedModalService } from './MediaExpandedModal.service'
import Tabs from 'components/Shared/Tabs'
import classnames from 'classnames'

const MediaExpandedModal = (props) => {
  const { expandedImage, onBack, onNext, isFirstItem, isLastItem } = props

  if (!expandedImage) return null

  const { tabsData, currentTab, setCurrentTab } = useMediaExpandedModalService({ expandedImage })

  return (
    <div className="media-uploads_preview">
      <Tabs tabsData={tabsData} currentTab={currentTab} handleTabChange={setCurrentTab} />

      <div className="media-uploads_preview_wrapper">
        <footer className="media-uploads_preview_navigation">
          <LeftArrowCircleIcon
            onClick={() => onBack(expandedImage)}
            className={classnames('left', { disabled: isFirstItem })}
          />

          <RightArrowCircleIcon
            onClick={() => onNext(expandedImage)}
            className={classnames('right', { disabled: isLastItem })}
          />
        </footer>
      </div>
    </div>
  )
}

export default MediaExpandedModal